<app-header></app-header>

<div class="page-container">
    <div class="Pane-container">
        <div class="background-container" [ngStyle]="{ 'background': getBackground(articles[0].thumbnail), 'background-size': 'cover' }">
            <div class="background" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(24, 75, 120, .85)"></div>
        </div>
        <div class="Pane">
            <!-- Pinned Article -->
            <div class="space adaptive large"></div>
            <div class="section-header">
                <h1 class="h4 text-upper text-priority-1-light">Kiemelt cikk</h1>
            </div>
            <div class="pinned-article">
                <article-list-item [article]="articles[0]"></article-list-item>
            </div>
            <div class="space adaptive large"></div>
        </div>
    </div>

    <div class="Pane-container">
        <div class="background-container">
            <div class="background" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(24, 75, 120, 1)"></div>
        </div>
        <div class="Pane">
            <!-- Page section header -->
            <div class="section-header">
                <h1 class="h4 text-upper text-priority-1-light">Sajtómegjelenések</h1>
            </div>
            <!-- Article list -->
            <div class="ArticleList">
                <article-list-item *ngFor="let article of articleList()" [article]="article"></article-list-item>
            </div>

            <div class="space adaptive large"></div>
        </div>
    </div>
</div>

<app-footer></app-footer>
